import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FarmOptionsTypes } from '../components/CustomizeColumns/types';
import { RootState } from './rootReducer';
import { Nullable } from '../common/types';

export const tableColumnsInitialState: FarmOptionsTypes.InitialState = {
  selectedColumns: null,
};

export const tableColumns = createSlice({
  name: 'tableColumns',
  initialState: tableColumnsInitialState,
  reducers: {
    addOrRemoveColumns: (
      state,
      action: PayloadAction<{
        key: string;
        columns: FarmOptionsTypes.Selection[];
      }>,
    ) => {
      const { key, columns } = action.payload;
      if (!state.selectedColumns) {
        state.selectedColumns = {};
      }

      state.selectedColumns[key] = columns;
    },
    resetTableColumns: () => tableColumnsInitialState,
  },
});

export const { addOrRemoveColumns, resetTableColumns } = tableColumns.actions;

// selectors
export const selectColumns = createSelector(
  (state: RootState) => state.tableColumns.selectedColumns,
  (columns): Nullable<FarmOptionsTypes.Selection[]> => {
    return columns ? Object.values(columns).flat() : null;
  },
);

export const selectColumnsByFilterName = createSelector(
  (state: RootState) => state.tableColumns.selectedColumns,
  (_: RootState, filterName: string) => filterName,
  (columns, filterName): Nullable<FarmOptionsTypes.Selection[]> => {
    if (!columns) {
      return null;
    }

    return columns[filterName];
  },
);

export default tableColumns.reducer;
